export default "__VITE_ASSET__Bmu6OCs0__"